import React, { useEffect, useState } from "react";
import Footer from "../../components/footer/Footer";
import Navigation from "../../components/navigation/Navigation";
import "./searchProduct.css";
import queryString from "query-string";
import axios from "axios";
import { ENDPOINT } from "../../helpers/Helper";
import { Col, Row, Spinner } from "react-bootstrap";
import ProductCard from "../../components/product-card/ProductCard";
import Button from "../../components/button/Button";
import { useNavigate } from "react-router-dom";

const renderLoading = () => (
  <div style={{ display: "flex", justifyContent: "center", padding: "10rem" }}>
    <Spinner animation="border" variant="dark" />
  </div>
);

function SearchProduct() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState();
  const [productName, setProductName] = useState();

  useEffect(() => {
    window.scrollTo(0, 0);

    setLoading(true);

    const { product } = queryString.parse(window.location.search);
    setProductName(product);

    axios
      .get(`${ENDPOINT}/products?search=${product}`)
      .then((res) => {
        setSearchData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        navigate("/error");
      });
  }, [window.location.search]);

  return (
    <div className="search_product">
      <Navigation
        background="theme-color"
        logo="https://res.cloudinary.com/emacon-production/image/upload/v1654424700/the-outlet/2_cx772d.png"
      />

      <div className="search_product-content">
        <h5>{`Products related to ${productName}`}</h5>

        {loading ? (
          renderLoading()
        ) : (
          <React.Fragment>
            {searchData && searchData.length <= 0 ? (
              <div className="no_products">
                <img
                  src="https://res.cloudinary.com/emacon-production/image/upload/v1642668903/the-outlet/undraw_Cancel_re_ctke_fhhejh.png"
                  alt=""
                />
                <h5>
                  Oops! Seems like we can't fing the product you are looking for
                </h5>
                <Button
                  action="/"
                  buttonColor="main-bg"
                  content="GO HOME"
                  borderRadius="all"
                />
              </div>
            ) : (
              <Row className="search_product-products">
                {searchData &&
                  searchData.map((item, index) => (
                    <Col xl={2} lg={4} md={3} sm={6} xs={6}>
                      <ProductCard product={item} />
                    </Col>
                  ))}
              </Row>
            )}
          </React.Fragment>
        )}
      </div>

      <Footer />
    </div>
  );
}

export default SearchProduct;
